import React, { Suspense, useEffect } from 'react';

import { propertyService } from '@lib/state';

interface Props {
  customerCode?: string | undefined;
}

export const ResourceLoader: React.FC<Props> = ({ customerCode, children }) => {
  useEffect(() => {
    propertyService.loadProperties(customerCode);
  }, [customerCode]);

  return <Suspense fallback={null}>{children}</Suspense>;
};
